import React from 'react';
import { FadeIn } from './FadeIn';
export function HackSection() {
  return <section className="py-16 md:py-32 relative" data-id="element-124">
      {/* Background Image with Parallax feel */}
      <div className="absolute inset-0 z-0" data-id="element-125">
        <img src="https://images.unsplash.com/photo-1502161254066-6c74afbf07aa?q=80&w=2000&auto=format&fit=crop" alt="Dark Parisian Cafe" className="w-full h-full object-cover opacity-20 fixed" data-id="element-126" />
        <div className="absolute inset-0 bg-gradient-to-b from-deep-black via-deep-black/90 to-deep-black" data-id="element-127"></div>
      </div>

      <div className="max-w-5xl mx-auto px-6 relative z-10" data-id="element-128">
        <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-129">
          <FadeIn direction="right" data-id="element-130">
            <div className="relative flex items-center justify-center" data-id="element-131">
              <div className="bg-glass-burgundy backdrop-blur-xl border border-champagne-gold/40 p-8 rounded-3xl max-w-xs shadow-gold-glow" data-id="element-132">
                <p className="font-playfair text-xl text-champagne-gold italic mb-2" data-id="element-133">
                  "L'ingénierie de l'attraction"
                </p>
              </div>
            </div>
          </FadeIn>

          <div className="space-y-8" data-id="element-134">
            <FadeIn delay={0.2} data-id="element-135">
              <h2 className="font-playfair text-4xl md:text-5xl text-cream leading-tight" data-id="element-136">
                Le secret n’est pas d'être "plus belle".
                <br data-id="element-137" />
                <span className="text-champagne-gold" data-id="element-138">
                  Le secret est d’être Stratégique.
                </span>
              </h2>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-139">
              <p className="text-muted-cream font-light leading-relaxed text-lg" data-id="element-140">
                Les femmes les plus courtisées ne sont pas forcément les plus
                jolies. Ce sont celles qui maîtrisent l'ingénierie de
                l'attraction. Elles savent exactement quand répondre, quoi
                écrire et surtout…{' '}
                <strong className="text-white font-medium" data-id="element-141">
                  quand ne rien dire du tout.
                </strong>
              </p>
            </FadeIn>

            <FadeIn delay={0.6} data-id="element-142">
              <div className="p-6 border-l-2 border-champagne-gold bg-gradient-to-r from-champagne-gold/10 to-transparent" data-id="element-143">
                <h3 className="font-playfair text-2xl text-cream mb-3" data-id="element-144">
                  Le "Chaud-Froid Cognitif"
                </h3>
                <p className="text-muted-cream font-light text-sm leading-relaxed" data-id="element-145">
                  Un protocole basé sur la psychologie comportementale qui
                  transforme un homme distrait en un homme qui vérifie son
                  téléphone toutes les 10 minutes en espérant votre réponse.
                </p>
              </div>
            </FadeIn>

            <FadeIn delay={0.8} data-id="element-146">
              <p className="text-xl font-playfair text-champagne-gold italic" data-id="element-147">
                Ce n'est pas de la manipulation. C'est de la physique
                émotionnelle. Et ça commence dès la première lecture.
              </p>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}